import React, { useCallback, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { ButtonSize, TextButton } from '@prisjakt/ui/button/variants';

type Props = {
  property?: string;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  clearFilter: (property?: string) => void;
};

const ClearButton = ({
  property,
  onClick,
  disabled,
  className,
  clearFilter,
}: Props) => {
  const { t } = useContext(AppContext);
  const onClickHandler = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick();
    }
    clearFilter(property);
  }, [onClick, clearFilter, property]);

  return (
    <TextButton
      className={className}
      onClick={onClickHandler}
      disabled={disabled}
      size={ButtonSize.SMALL}
      containerProps={{ 'data-test': 'FeaturedFilterClear' }}
    >
      {t('filter', 'button.clear-filter')}
    </TextButton>
  );
};

export default ClearButton;
